import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { LANGUAGES } from './i18n.type'

@Injectable({
  providedIn: 'root',
})
export class TranslationLoaderService {


  private readonly defaultLanguage = LANGUAGES['pt-BR']

  public constructor(private readonly translateService: TranslateService) {}

  public initialize(): void {
    this.setTranslations()
    this.setLanguage()
  }

  private setTranslations(): void {
    for (const languageKey in LANGUAGES) {
      if (Object.hasOwn(LANGUAGES, languageKey)) {
        const language = LANGUAGES[languageKey]
        this.translateService.setTranslation(language.code, language.translations, true)
      }
    }
  }

  private setLanguage(): void {
    const browserLanguage = this.translateService.getBrowserLang()
    const browserLanguageTranslation = browserLanguage && Object.values(LANGUAGES).find((lang) => {
      return lang.code === browserLanguage || lang.dateCode === browserLanguage
    })

    const translationLanguage = browserLanguageTranslation
      ? browserLanguageTranslation.code
      : this.defaultLanguage.code

    this.translateService.use(translationLanguage).subscribe()
  }

}
